<!-- ---TEMPLATE--- --> 
<template>
  <div>
    <el-row>
      <!-- the row, going to repeat -->
      <div class="rowSpan24 newsTab24 newsArticleSpan24" id="newsTabFontSizeChange" v-loading.fullscreen.lock="fullscreenLoading">
      <el-menu class="el-menu-demo" mode="horizontal">
        <el-menu-item index="1">
          <div class="menuTitle"  v-for="(set,index) in groups" v-bind:key="index">
            <div class="newsTitle" v-on:click="set.open = !set.open" v-if="getScRegisterFlag">新聞({{getNewsFirstTabCheckboxValue}}/{{getThemeNewsCount}}件)</div>
            <div class="newsTitle" v-on:click="set.open = !set.open" v-else>新聞(未登録)</div>
          </div>
        </el-menu-item>        
        <el-menu-item index="2">
          <div class="menuLable" v-if="getSortDateText">
            <div class="selectList year-drop">年月日：{{getSelectedSortDate}}</div>
            <i class="el-icon-arrow-up year-arrow" v-if="getAscendingDateIcon"></i>
            <i class="el-icon-arrow-down year-arrow" v-if="getDecendingDateIcon"></i>
          </div>
          <div class="menuLable" v-if="getSortTitleText">
            <div class="selectList year-drop">見出し：{{getSelectedSortTitle}}</div>
            <i class="el-icon-arrow-up year-arrow" v-if="getAscendingTitleIcon"></i>
            <i class="el-icon-arrow-down year-arrow" v-if="getDecendingTitleIcon"></i>
          </div>
        </el-menu-item>
        <el-menu-item index="3">
          <div class="strip first-strip" v-if="getSortDateText == true || getSortTitleText == true"></div>
        </el-menu-item>
        <el-menu-item index="4" class="select_custom" v-if="all_articles_selectable_flag">
          <div class="menuLable">
            <el-checkbox class="checkList newsCheckList select_custom_box" v-model="getNewsTabCheckboxSelectDetails" @change="handleCheckAllChange">
              <div class="selectList select_custom_label">全て選択</div>
            </el-checkbox>
          </div>
        </el-menu-item>
        <el-menu-item index="5">
          <div class="strip" v-if="all_articles_selectable_flag"></div>
          <div style="width: 6px;" v-else></div>
        </el-menu-item>
        <el-menu-item index="6">
          <div class="sortIcon">
            <el-popover placement="bottom-start" width="200" trigger="click" v-model="visible" class="bigPopUp">
              <div class="menuLable" slot="reference">
                <div class="iconSVG ico_sort_up" tabindex="0"></div>
                <div class="IconSort">ソート</div>   
              </div> 
              <template>
                <el-form class="selectForm">
                  <el-form-item label="年月日" class="dateSelectLable">
                    <el-select v-model="getNewsDateValue" class="dateSelect" @change="selectDateValue($event)">
                      <div class="drop1">
                        <el-option
                          class="dateOption"
                          v-for="item in NewsOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="見出し" class="headingLable">
                    <el-select v-model="getNewsTitleValue" class="heading" @change="selectTitleValue($event)">
                      <div class="drop2">
                        <el-option
                          class="headingOption"
                          v-for="items in NewsOptions2"
                          :key="items.value"
                          :label="items.label"
                          :value="items.value"
                        ></el-option>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-row type="flex" justify="space-between">
                    <el-button round class="roundGray" tabindex="1"  @click="clear">リセット</el-button>
                    <el-row>
                      <el-button round class="roundGrayDark" tabindex="1" @click="cancelSort">キャンセル</el-button>
                      <el-button round class="roundBlue" tabindex="1" @click="articleSorting">OK</el-button>
                    </el-row>
                  </el-row>
                </el-form>
              </template>
            </el-popover>
          </div>
        </el-menu-item>
        <el-menu-item index="7">
          <div class="strip"></div>
        </el-menu-item>
        <el-menu-item index="8">
          <div class="menuLable">
            <div @click="sendTo1043Screen" class="iconSVG ico_print_up" tabindex="0"></div>
            <div @click="sendTo1043Screen" class="printfile">一括印刷</div>
          </div>
        </el-menu-item>
        <el-menu-item index="9">
          <div class="menuLable">
            <div class="iconSVG batchDisplay ico_batch-display_up" @click="batchProcess" tabindex="0"></div>
            <div class="fileDetail" @click="batchProcess">一括表示</div>
          </div>
        </el-menu-item>
        <el-menu-item index="10">
          <div class="menuLable" v-if="csv_download_flag">
            <div class="iconSVG csvOutput ico_csv-output_up" @click="downloadArticleAsCsvFormat" tabindex="0"></div>
            <div class="csvFile" @click="downloadArticleAsCsvFormat">CSV出力</div>
          </div>
        </el-menu-item>
      </el-menu>
        </div>
      <el-col :span="24">
        <div class="accord">
          <div v-for="(set,index) in groups" v-bind:key="index">
            <div id="anim">
              <transition name="slide">
                <el-collapse-transition>
                  <div class="colloapse_none">
                    <div v-for="(item,index) in set.items" v-bind:key="index">
                      <el-checkbox-group v-model="getArticleDetails"  @change="handleCheckedArticlesChange">
                        <NewsTabDraggable ref="NewsTabDraggableRef" v-bind:articleList="getNikkieArticle"/>
                      </el-checkbox-group>
                    </div>
                  </div>
                </el-collapse-transition>
              </transition>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<!-- --SCRIPT--- -->
<script>
import { mapGetters } from "vuex";
import NewsTabDraggable from "./NewsTabDraggable.vue";
import json from "../../components/config.json";
import $ from "jquery";
import Vue from 'vue';

export default {
  components: {
    NewsTabDraggable
  },
  data() {
    return {
      fullscreenLoading: false,
      visible: false,
      groups: {
        "group 1": {
          name: "Menu 1",
          open: "false",
          items: ["item1"]
        }
      },
      drag: false,
      select_date_value: '',
      select_title_value: '',
      selectedSortDate: '',
      selectedSortTitle: '',
      NewsOptions: [
        {
          value: "なし",
          label: "なし"
        },
        {
          value: "昇順",
          label: "昇順"
        },
        {
          value: "降順",
          label: "降順"
        }
      ],
      NewsOptions2: [
        {
          value: "なし",
          label: "なし"
        },
        {
          value: "昇順",
          label: "昇順"
        },
        {
          value: "降順",
          label: "降順"
        }
      ],
      startDateResult: '',
      endDateResult: '',
      scroll_sort_date: '',
      scroll_sort_title: '',
      userId: '',
      contractId: '',
      theme_browsing: '',
      checklistVal: [],
      checkAll: false,
      isActive: false,
      isMedActive: true,
      isBigActive: false,
      csv_download_flag: false,
      all_articles_selectable_flag: false,
      collective_demand_max_count: "0",
      print_confirm_dialog_flag: "0",
      setCancelValue: true,
      contract_code: '',
      session_id: '',
      user_group_name: '',
      display_delay_message_min: "0"
    };
  },
  methods: {
    cancelSort(){
      this.$LogButtonEvent("newstab","Cancell");
      this.$LogMethodIN("newstab","cancelSort");
      if(this.setCancelValue)
      {
        this.$store.commit('situation/setNewsDateValue', 'なし');
        this.$store.commit('situation/setNewsTitleValue', 'なし');
        this.select_date_value='';
        this.select_title_value='';
        this.$store.commit('situation/setSortDateText', false);
        this.$store.commit('situation/setSortTitleText', false);
        this.$store.commit('situation/setAscendingDateIcon', false);
        this.$store.commit('situation/setDecendingDateIcon', false);
        this.$store.commit('situation/setAscendingTitleIcon', false);
        this.$store.commit('situation/setDecendingTitleIcon', false);
      }
      else
      {
        if(this.getSelectedSortDate != '')
        {
          this.$store.commit('situation/setNewsDateValue', this.getSelectedSortDate);
          this.$store.commit('situation/setNewsTitleValue', 'なし');

        }
        else if(this.getSelectedSortTitle != '')
        {
          this.$store.commit('situation/setNewsDateValue', 'なし');
          this.$store.commit('situation/setNewsTitleValue', this.getSelectedSortTitle);
        }
      }
      this.visible = false
      this.$LogMethodOut("newstab","cancelSort");
    },
    //method for sorting the article based on article date and title
    articleSorting(){
      this.$LogButtonEvent("newstab","ArticleSorting");
      this.$LogMethodIN("newstab","articleSorting");
      //set the date and title sort values which is selected in All Media Tab
      this.select_date_value = this.getNewsDateValue;
      this.select_title_value = this.getNewsTitleValue;

      // 2021/05/25  #11297  START  
      if(this.$store.getters['situation/getSortDateText'])
      {
        if((this.select_date_value == "昇順" && !this.$store.getters['situation/getAscendingDateIcon']) ||
        (this.select_date_value == "降順" && !this.$store.getters['situation/setDecendingDateIcon']) ||
        (this.select_date_value == "なし" || this.select_date_value == ''))
        {
          if(this.getArticleDetails.length != 0)
          {
            this.$store.commit("situation/setArticleDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit('situation/setNewsFirstTabCheckboxValue', 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getNewsTabCheckboxSelectDetails'])
          {
            this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
          }
        }
      }
      else if(this.$store.getters['situation/getSortTitleText'])
      {
        if((this.select_title_value == "昇順" && !this.$store.getters['situation/getAscendingTitleIcon']) ||
        (this.select_title_value == "降順" && !this.$store.getters['situation/setDecendingTitleIcon']) ||
        (this.select_title_value == "なし" || this.select_title_value == ''))
        {
          if(this.getArticleDetails.length != 0)
          {
            this.$store.commit("situation/setArticleDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit('situation/setNewsFirstTabCheckboxValue', 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getNewsTabCheckboxSelectDetails'])
          {
            this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
          }
        }
      }
      else if((this.select_title_value == "昇順" || this.select_title_value == '降順' ||
      this.select_date_value == "昇順" || this.select_date_value == "降順")
      && !this.$store.getters['situation/getSortDateText']
      && !this.$store.getters['situation/getSortTitleText'])
      {
        if(this.getArticleDetails.length != 0)
          {
            this.$store.commit("situation/setArticleDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit('situation/setNewsFirstTabCheckboxValue', 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getNewsTabCheckboxSelectDetails'])
          {
            this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
          }
      }
      // 2021/05/25  #11297  END

      if(this.select_date_value != '' && this.select_date_value != 'なし')
      {
        this.$store.commit('situation/setSelectedSortDate', this.select_date_value);
        this.$store.commit('situation/setSelectedSortTitle', '');

        this.$store.commit('situation/setSortDateText', true);
        this.$store.commit('situation/setSortTitleText', false);
        if(this.select_date_value == "昇順")
        {
          this.scroll_sort_date = 'asc';
          this.scroll_sort_title = '';
          this.$store.commit('situation/setAscendingDateIcon', true);
          this.$store.commit('situation/setDecendingDateIcon', false);
        }
        else if(this.select_date_value == "降順")
        {
          this.scroll_sort_date = 'desc';
          this.scroll_sort_title = '';
          this.$store.commit('situation/setAscendingDateIcon', false);
          this.$store.commit('situation/setDecendingDateIcon', true);
        }
      }
      else if(this.select_title_value != '' && this.select_title_value != 'なし')
      {
        this.$store.commit('situation/setSelectedSortDate', '');
        this.$store.commit('situation/setSelectedSortTitle', this.select_title_value);

        this.$store.commit('situation/setSortDateText', false);
        this.$store.commit('situation/setSortTitleText', true);
        if(this.select_title_value == "昇順")
        {
          this.scroll_sort_title = 'asc';
          this.scroll_sort_date = '';
          // 2021/06/28  #11594  START
          this.$store.commit('situation/setAscendingTitleIcon', true);
          this.$store.commit('situation/setDecendingTitleIcon', false);
          // 2021/06/28  #11594  END
        }
        else if(this.select_title_value == "降順")
        {
          this.scroll_sort_title = 'desc';
          this.scroll_sort_date = '';
          this.$store.commit('situation/setAscendingTitleIcon', false);
          this.$store.commit('situation/setDecendingTitleIcon', true);
        }
      }
      else if((this.select_date_value == 'なし' || this.select_date_value == '') && (this.select_title_value == 'なし' || this.select_title_value == ''))
      {
        this.scroll_sort_title = '';
        this.scroll_sort_date = '';
        this.$store.commit('situation/setSelectedSortDate', 'なし');
        this.$store.commit('situation/setSelectedSortTitle', 'なし');
        this.$store.commit('situation/setSortDateText', false);
        this.$store.commit('situation/setSortTitleText', false);
      }
      this.setCancelValue = false
      var themeValue = this.getSelectedTheme[0].value
      var theme_id = this.getSelectedTheme[0].id
      var inputParam;
      if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if article is loaded based on theme values
      {
        if(themeValue == "Theme")//if selected theme value is theme
        {
          inputParam ={
            contract_id: this.contractId,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getTotalNewsCount,
            theme_id: theme_id
          }
        }
        else if(themeValue == "Theme Group")//if selected theme value is theme group
        {
          inputParam ={
            contract_id: this.contractId,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getTotalNewsCount,
            theme_group_id: theme_id
          }
        }
        else//if selected theme value is topics
        {
          inputParam ={
            contract_id: this.contractId,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getTotalNewsCount,
            topics_id: theme_id
          }
        }

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article(AID0005)
        Vue.prototype.$session.set('InputParameterFor0006',inputParam);
        Vue.prototype.$session.set('CurrentAID',"0005");
        this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if article is loaded based on today's article values
      {
        inputParam ={
          contract_id: this.contractId,
          process_date_start:this.getDefaultThemeStartDate,
          process_date_end:this.getDefaultThemeEndDate,
          sort_date: this.scroll_sort_date,
          sort_title: this.scroll_sort_title,
          start_num:1,
          load_num:this.getTotalNewsCount
        }

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article(AID0005)
        Vue.prototype.$session.set('InputParameterFor0006',inputParam);
        Vue.prototype.$session.set('CurrentAID',"0005");
        this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
        
      }
      else if(this.getSearchConditionKey == 1)//if article is loaded based on search condition
      {
        if(this.getSearchValue != '')//if value is selected from search dropdown
        {
          inputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 1,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            search_title: this.getSearchValue,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getTotalNewsCount
          }
        }
        else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
        {
          if(this.getMediaValue != '')//if media texbox is not equal to empty
          {
            inputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 1,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              key_word: this.getKeywordValue,
              media_name: this.getMediaValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getTotalNewsCount
            }
          }
          else//if media texbox is equal to empty
          {
            inputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 1,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              key_word: this.getKeywordValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getTotalNewsCount
            }
          }
        }
        else//if keyword textbox is equal to empty
        {
          if(this.getMediaValue != '')//if media texbox is not equal to empty
          {
            inputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 1,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              media_name: this.getMediaValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getTotalNewsCount
            }
          }
          else//if media texbox is equal to empty
          {
            inputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 1,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getTotalNewsCount
            }
          }
        }

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article(AID0071)
        this.$store.dispatch('communication/getNewsArticleUsingSorting', inputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else if(this.getSearchConditionKey == 2)
      {
        if(this.getKeywordValue != '')
        {
          inputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 1,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            key_word: this.getKeywordValue,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getTotalNewsCount
          }
        }
        else
        {
          inputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 1,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getTotalNewsCount
          }
        }
        

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article(AID0071)
        this.$store.dispatch('communication/getNewsArticleUsingSorting', inputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else
      {
        //no action needed
      }
      this.$LogMethodOut("newstab","articleSorting");
    },
    ToggleElementTab: function() {
      $(".NewRotate").toggleClass("down");
    },
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },
    //method for reset the date and title value for sorting the article
    clear (){
      this.$LogButtonEvent("newstab","Reset");
      this.$LogMethodIN("newstab","clear");
      this.$store.commit('situation/setNewsDateValue', 'なし');
      this.$store.commit('situation/setNewsTitleValue', 'なし');
      this.select_date_value='';
      this.select_title_value='';
      this.scroll_sort_date = '';
      this.scroll_sort_title = '';
      this.$LogMethodOut("newstab","clear");
    },
    //method for get the article no from selected article checkboxex
    handleCheckAllChange(val){
      this.$LogButtonEvent("newstab","SelectAll");
      this.$LogMethodIN("newstab","handleCheckAllChange");
      if(val)
      {
        if(this.getNikkieArticle.length == this.getThemeNewsCount)
        {
          this.checklistVal = val ? this.getArticlesIds() : [];
          this.$store.commit('situation/setArticleDetails', this.checklistVal);
          if(this.checklistVal.length > 0)
          {
            // 2024/05/15  #17821  START
            if(!this.csv_download_flag){
              var cnt = this.getNikkieArticle.length;
              for(var i=0;i<this.getNikkieArticle.length;i++){
                if(this.getNikkieArticle[i].no_image_flag){
                  cnt=cnt-1;
                }
              }
              this.$store.commit("situation/setNewsFirstTabCheckboxValue", cnt);
              this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
            }else{
              this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
              this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
            }
            // 2024/05/15  #17821  END
          }
          else
          {
            this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
            this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
          }
        }
        else
        {
          var themeValue = this.getSelectedTheme[0].value;
          var theme_id = this.getSelectedTheme[0].id;
          var startNumCount = this.getNikkieArticle.length + 1;
          var loadNumCount = this.getThemeNewsCount - this.getNikkieArticle.length
          var inputParam;
          
          if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
          {
            
            if(themeValue == "Theme")
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingDate,
                sort_title: this.getScrollingTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                theme_id: theme_id
              };
            }
            else if(themeValue == "Theme Group")
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingDate,
                sort_title: this.getScrollingTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                theme_group_id: theme_id
              };
            }
            else
            {
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingDate,
                sort_title: this.getScrollingTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                topics_id: theme_id
              };
            }

            var existingArticleDetails = []

            existingArticleDetails = [...existingArticleDetails, inputParam, this.getNikkieArticle]

            
            this.fullscreenLoading = true;
            Vue.prototype.$session.set('InputParameterFor0006',inputParam);
            Vue.prototype.$session.set('CurrentAID',"0005");
            this.$store.dispatch('communication/getNewspaperArticles', existingArticleDetails)
            .then(() => {
              this.fullscreenLoading = false
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setArticleDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                // 2024/05/15  #17821  START
                if(!this.csv_download_flag){
                  var cnt = this.getNikkieArticle.length;
                  for(var i=0;i<this.getNikkieArticle.length;i++){
                    if(this.getNikkieArticle[i].no_image_flag){
                      cnt=cnt-1;
                    }
                  }
                  this.$store.commit("situation/setNewsFirstTabCheckboxValue", cnt);
                  this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
                }else{
                  this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
                }
                // 2024/05/15  #17821  END
              }
              else
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
              }
            }).catch(()=>{
              this.fullscreenLoading = false
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setArticleDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
              }
              else
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
              }
            });
          }
          else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
          {
            
            inputParam = {
              contract_id: this.contractId,
              process_date_start: this.getDefaultThemeStartDate,
              process_date_end: this.getDefaultThemeEndDate,
              sort_date: this.getScrollingDate,
              sort_title: this.getScrollingTitle,
              start_num: startNumCount,
              load_num: loadNumCount
            };

            var existingTodayArticleDetails = [];

            existingTodayArticleDetails = [...existingTodayArticleDetails, inputParam, this.getNikkieArticle]

            
            this.fullscreenLoading = true;
            Vue.prototype.$session.set('InputParameterFor0006',inputParam);
            Vue.prototype.$session.set('CurrentAID',"0005");
            this.$store.dispatch('communication/getNewspaperArticles', existingTodayArticleDetails).then(() => {
              this.fullscreenLoading = false
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setArticleDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                // 2024/05/15  #17821  START
                if(!this.csv_download_flag){
                  var cnt = this.getNikkieArticle.length;
                  for(var i=0;i<this.getNikkieArticle.length;i++){
                    if(this.getNikkieArticle[i].no_image_flag){
                      cnt=cnt-1;
                    }
                  }
                  this.$store.commit("situation/setNewsFirstTabCheckboxValue", cnt);
                  this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
                }else{
                  this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
                }
                // 2024/05/15  #17821  END
              }
              else
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
              }
            }).catch(()=>{
              this.fullscreenLoading = false
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setArticleDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
              }
              else
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
              }
            });
          }
          else if(this.getSearchConditionKey == 1)
          {
            if(this.getSearchValue != '')
            {
              inputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 1,
                display_id: 'SID0002',
                process_date_from: this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                search_title: this.getSearchValue,
                sort_date: this.getScrollingDate,
                sort_title: this.getScrollingTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }
            else if(this.getKeywordValue != '')
            {
              if(this.getMediaValue != '')
              {
                inputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: 'SID0002',
                  process_date_from: this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
              else
              {
                inputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: 'SID0002',
                  process_date_from: this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
            }
            else
            {
              if(this.getMediaValue != '')
              {
                inputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: 'SID0002',
                  process_date_from: this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
              else
              {
                inputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: 'SID0002',
                  process_date_from: this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
            }

            var existingSearchArticle = [];

            existingSearchArticle = [...existingSearchArticle, inputParam, this.getNikkieArticle];

            this.fullscreenLoading = true;
            //Api call for sorting the news article(AID0071)
            this.$store.dispatch('communication/getNewsArticleUsingSorting', existingSearchArticle)
            .then(() => {
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setArticleDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
              }
              else
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
              }
            }).catch(()=>{
              this.fullscreenLoading = false
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setArticleDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
              }
              else
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
              }
            });
          }
          else if(this.getSearchConditionKey == 2)
          {
            if(this.getKeywordValue != '')
            {
              inputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 1,
                display_id: 'SID0002',
                process_date_from:this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                key_word: this.getKeywordValue,
                sort_date: this.getScrollingDate,
                sort_title: this.getScrollingTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }
            else
            {
              inputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 1,
                display_id: 'SID0002',
                process_date_from:this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: this.getScrollingDate,
                sort_title: this.getScrollingTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }

            var existingSearchKeywordArticle = [];

            existingSearchKeywordArticle = [...existingSearchKeywordArticle, inputParam, this.getNikkieArticle];

            this.fullscreenLoading = true;
            //Api call for sorting the news article(AID0071)
            this.$store.dispatch('communication/getNewsArticleUsingSorting', existingSearchKeywordArticle)
            .then(() => {
              this.fullscreenLoading = false
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setArticleDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
              }
              else
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
              }
            }).catch(()=>{
              this.fullscreenLoading = false
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setArticleDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
              }
              else
              {
                this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
              }
            });
          }
          else
          {
            //no action needed
          }
        }
      }
      else
      {
        this.checklistVal = val ? this.getArticlesIds() : [];
        this.$store.commit('situation/setArticleDetails', this.checklistVal);
        if(this.checklistVal.length > 0)
        {
          this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
          this.$store.commit('situation/setNewsTabCheckboxSelectDetails', true);
        }
        else
        {
          this.$store.commit("situation/setNewsFirstTabCheckboxValue", this.checklistVal.length);
          this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
        }
        this.$LogMethodOut("newstab","handleCheckAllChange");
      }
    },
    handleCheckedArticlesChange(value){
      this.$LogButtonEvent("newstab","CheckArticle");
      this.$LogMethodIN("newstab","handleCheckedArticlesChange");
      let checkedCount = value.length;

      this.checkAll = checkedCount === this.getNikkieArticle.length;
      this.$store.commit('situation/setNewsTabCheckboxSelectDetails', this.checkAll);
      this.$LogMethodOut("newstab","handleCheckedArticlesChange");
    },
    //method for get the value from date dropdown
    selectDateValue($event){
      this.$LogButtonEvent("newstab","selectDate");
      this.$LogMethodIN("newstab","selectDateValue");      
      for(var j=0; j<this.NewsOptions.length;j++)
      {
        if($event == this.NewsOptions[j].value)
        {
          this.select_date_value = this.NewsOptions[j]["value"];
        }
      }
      if(this.select_date_value == "昇順")
      {
        this.scroll_sort_date = 'asc';
        this.scroll_sort_title = '';
        this.select_title_value = '';
        this.$store.commit('situation/setNewsDateValue', '昇順');
        this.$store.commit('situation/setNewsTitleValue', 'なし');
      }
      else if(this.select_date_value == "降順")
      {
        this.scroll_sort_date = 'desc';
        this.scroll_sort_title = '';
        this.select_title_value = '';
        this.$store.commit('situation/setNewsDateValue', '降順');
        this.$store.commit('situation/setNewsTitleValue', 'なし');
      }
      else
      {
        this.scroll_sort_date = '';
        this.$store.commit('situation/setNewsDateValue', 'なし');
      }
      this.$store.commit("situation/setScrollingDate", this.scroll_sort_date);
      this.$LogMethodOut("newstab","selectDateValue");
    },
    //method for get the value from title dropdown
    selectTitleValue($event){
      this.$LogButtonEvent("newstab","selectTitle");
      this.$LogMethodIN("newstab","selectTitleValue");      
			for(var j=0; j<this.NewsOptions2.length;j++){
					if($event == this.NewsOptions2[j].value){
            this.select_title_value = this.NewsOptions2[j]["value"];
					}
      }
      if(this.select_title_value == "昇順")
      {
        this.scroll_sort_title = 'asc';
        this.scroll_sort_date = '';
        this.select_date_value = '';
        this.$store.commit('situation/setNewsDateValue', 'なし');
        this.$store.commit('situation/setNewsTitleValue', '昇順');
      }
      else if(this.select_title_value == "降順")
      {
        this.scroll_sort_title = 'desc';
        this.scroll_sort_date = '';
        this.select_date_value = '';
        this.$store.commit('situation/setNewsDateValue', 'なし');
        this.$store.commit('situation/setNewsTitleValue', '降順');
      }
      else
      {
        this.scroll_sort_title = '';
        this.$store.commit('situation/setNewsTitleValue', 'なし');
      }
      this.$store.commit('situation/setScrollingTitle', this.scroll_sort_title);
      this.$LogMethodOut("newstab","selectTitleValue");
    },
    // method for redirecting to SID0004 screen with multiple article
    batchProcess(){
      this.$LogButtonEvent("newstab","SvgBatchDisplay");
      this.$LogMethodIN("newstab","batchProcess");
      var article_details = [];
      var pdfCompletionArray = [];
      var newsArticle = this.getNikkieArticle;
      if(this.getArticleDetails.length != 0)
      {
        if(this.getArticleDetails.length <= this.collective_demand_max_count)
        {
          // for(var i=0;i<this.getArticleDetails.length;i++)
          // {
          //   for(var j=0;j<newsArticle.length;j++)
          //   {
          //     if(newsArticle[j].article_no == this.getArticleDetails[i])
          //     {
          //       article_details = [...article_details, {article_id: newsArticle[j].article_id, data_section: newsArticle[j].data_section}];
          //       pdfCompletionArray = [...pdfCompletionArray, {contract_id: this.contractId, data_section: newsArticle[j].data_section, user_id: this.userId, request_div: 1, article_id: newsArticle[j].article_id, session_id: this.session_id, user_group_name: this.user_group_name, theme_id: this.getThemeIdForPdfSuccess, theme_group_id: this.getThemeGroupIdForPdfSuccess, topics_id: this.getTopicsIdForPdfSuccess}]
          //     }
          //   }
            
          // }
          //Modified for BT08460_EXTERNAL-1784
          for(var i=0;i<newsArticle.length;i++)
          {
            for(var j=0;j<this.getArticleDetails.length;j++)
            {
              if(newsArticle[i].article_no == this.getArticleDetails[j])
              {
                 // 2024/05/15  #17821  START
                if(!this.csv_download_flag){
                  if(!newsArticle[i].no_image_flag){
                    article_details.push({
                    article_id: newsArticle[i].article_id,
                    data_section: newsArticle[i].data_section
                    });
                    pdfCompletionArray.push({
                      contract_id: this.contractId, 
                      data_section: newsArticle[i].data_section, 
                      user_id: this.userId, read_count: 1, 
                      request_div: 1, 
                      article_id: newsArticle[i].article_id, 
                      session_id: this.session_id, 
                      user_group_name: this.user_group_name, 
                      theme_id: this.getThemeIdForPdfSuccess, 
                      theme_group_id: this.getThemeGroupIdForPdfSuccess, 
                      topics_id: this.getTopicsIdForPdfSuccess
                    });
                  }
                }else{
                  article_details.push({
                    article_id: newsArticle[i].article_id, 
                    data_section: newsArticle[i].data_section
                  });
                  pdfCompletionArray.push({
                    contract_id: this.contractId, 
                    data_section: newsArticle[i].data_section, 
                    user_id: this.userId, 
                    request_div: 1, 
                    article_id: newsArticle[i].article_id, 
                    session_id: this.session_id, 
                    user_group_name: this.user_group_name, 
                    theme_id: this.getThemeIdForPdfSuccess, 
                    theme_group_id: this.getThemeGroupIdForPdfSuccess, 
                    topics_id: this.getTopicsIdForPdfSuccess
                  });
                }
                // 2024/05/15  #17821  END
              }
            }
          }

          var pdfValues = {
            pdf_flag:1,
            article_info:article_details,
            user_id:this.userId,
            contract_code:this.contract_code,
            theme_browsing:this.theme_browsing,
            display_id:"SID0002",
            is_mail:false
          };
          var pdfSuccessValues = {
            data_info: pdfCompletionArray
          };
          
          var pdfCombinedArray = [];

          pdfCombinedArray = [...pdfCombinedArray, pdfValues, pdfSuccessValues];
          if(this.getOut_Demand_Confirm_Message_Div_Flag)
          {
            this.$confirm(
              this.getDemandConfirmPdfMessage,
              "確認",
              {
                confirmButtonText: "OK",
                cancelButtonText: "キャンセル"
              }
            ).then(() => {
              if(this.getArticleDetails.length >= this.display_delay_message_min && this.getArticleDetails.length <= this.collective_demand_max_count)
              {
                this.$confirm(
                  "表示件数が多いため表示処理に時間がかかりますがよろしいでしょうか？",
                  "確認",
                  {
                    confirmButtonText: "OK",
                    cancelButtonText: "キャンセル"
                  }
                ).then(() => {
                  /*******BT08460_EXTERNAL-1539 issue fix*******/
                  this.$session.set('pdfCombinedArray', pdfCombinedArray);
                  let routeData = this.$router.resolve({name: '0001-001'}); 
                  window.open(routeData.href, '_blank');
                  /*this.fullscreenLoading = true;
                  this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
                    this.fullscreenLoading = false;
                  }).catch(() => {
                    this.fullscreenLoading = false;
                  })*/
                  /*******BT08460_EXTERNAL-1539 issue fix*******/
                })
              }
              else
              {
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                this.$session.set('pdfCombinedArray', pdfCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                /*this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                }).catch(() => {
                  this.fullscreenLoading = false;
                })*/
                /*******BT08460_EXTERNAL-1539 issue fix*******/
              }
            })
          }
          else
          {
            // 2021/01/11 #10236 START
            if(this.getArticleDetails.length >= this.display_delay_message_min && this.getArticleDetails.length <= this.collective_demand_max_count)
            {
              this.$confirm(
                "表示件数が多いため表示処理に時間がかかりますがよろしいでしょうか？",
                "確認",
                {
                  confirmButtonText: "OK",
                  cancelButtonText: "キャンセル"
                }
              ).then(() => {
                this.$session.set('pdfCombinedArray', pdfCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
              })
            }
            else
            {
            // 2021/01/11 #10236 END
            /*******BT08460_EXTERNAL-1539 issue fix*******/
            this.$session.set('pdfCombinedArray', pdfCombinedArray);
            let routeData = this.$router.resolve({name: '0001-001'}); 
            window.open(routeData.href, '_blank');
            /*this.fullscreenLoading = true;
            this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
              this.fullscreenLoading = false;
            }).catch(() => {
              this.fullscreenLoading = false;
            })*/
            /*******BT08460_EXTERNAL-1539 issue fix*******/
            // 2021/01/11 #10236 START
            }
            // 2021/01/11 #10236 END
          }
        }
        else
        {
          this.$alert("1回に表示できる記事の上限値を超えています。","確認", {
            confirmButtonText: 'OK',
          })
        }
      }
      else
      {
        this.$confirm(
            json["1023_delete_confirm_message"],
            json["1023_delete_confirm_message_title"],
            {
              showCancelButton: false,
              confirmButtonText: "OK"
            }
          );
      }
      this.$LogMethodOut("newstab","batchProcess");
    },
    //method for download article as CSV format
    downloadArticleAsCsvFormat(){
      this.$LogButtonEvent("newstab","DownloadCsvFormat");
      this.$LogMethodIN("newstab","downloadArticleAsCsvFormat");      
      var article_details = [];
      var newsArticle = this.getNikkieArticle;
      var csvDownloadValues;
      if(this.getArticleDetails.length != 0)
      {
        // for(var i=0;i<this.getArticleDetails.length;i++)
        // {
        //   for(var j=0;j<newsArticle.length;j++)
        //   {
        //      if(newsArticle[j].article_no == this.getArticleDetails[i])
        //      {
        //        article_details = [...article_details, {article_id: newsArticle[j].article_id, data_section: newsArticle[j].data_section}];
        //      }
        //   }
        // }
        //Modified for BT08460_EXTERNAL-1784
        for(var i=0;i<newsArticle.length;i++)
        {
          for(var j=0;j<this.getArticleDetails.length;j++)
          {
             if(newsArticle[i].article_no == this.getArticleDetails[j])
             {
               article_details.push({
                 article_id: newsArticle[i].article_id, 
                 data_section: newsArticle[i].data_section
                });
             }
          }
        }
        
        var themeValue = this.getSelectedTheme[0].value;
        var theme_id = this.getSelectedTheme[0].id;
        if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
        {
          if(themeValue == "Theme")
          {
            csvDownloadValues = {
              theme_data_section:101,
              theme_name:theme_id,
              theme_group_name:null,
              topics_name:null,
              articles:article_details
            }
          }
          else if(themeValue == "Theme Group")
          {
            csvDownloadValues = {
              theme_data_section:101,
              theme_name:null,
              theme_group_name:theme_id,
              topics_name:null,
              articles:article_details
            }
          }
          else if(themeValue == "Topics")
          {
            csvDownloadValues = {
              theme_data_section:101,
              theme_name:null,
              theme_group_name:null,
              topics_name:theme_id,
              articles:article_details
            }
          }
          else
          {
            //no action needed
          }
        }
        else
        {
          csvDownloadValues = {
            theme_data_section:101,
            theme_name:null,
            theme_group_name:null,
            topics_name:null,
            articles:article_details
          }
        }
        
        this.$store.dispatch('communication/downloadArticleDeliveryList', csvDownloadValues).then(() => {
          //After the Ajax call finished check if status is error for showing alert
          var status = this.getCsvDownloadErrStatus;
          var msgdetail = this.getCsvDownloadErrmsgDetail;
          if(status == "1")
          {
            this.$alert(msgdetail,"更新", {  confirmButtonText: 'OK',  })
          }
          else
          {
            //console.log("else");
          }
        });
      }
      else
      {
        
        this.$confirm(
          json["1023_delete_confirm_message"],
          json["1023_delete_confirm_message_title"],
          {
            showCancelButton: false,
            confirmButtonText: "OK"
          }
        );
        
      }
      this.$LogMethodOut("newstab","downloadArticleAsCsvFormat");
    },
    //method for redirecting to print screen
    sendTo1043Screen(){
      this.$LogButtonEvent("nenewstabws","CsvDisplay1043");
      this.$LogMethodIN("newstab","sendTo1043Screen");
      var article_details = [];
      var printCompletionArray = [];
      var newsArticle = this.getNikkieArticle;
      if(this.getArticleDetails.length != 0)
      {
        if(this.getArticleDetails.length <= this.collective_demand_max_count)
        {
          // for(var i=0;i<this.getArticleDetails.length;i++)
          // {
          //   for(var j=0;j<newsArticle.length;j++)
          //   {
          //     if(newsArticle[j].article_no == this.getArticleDetails[i])
          //     {
          //       article_details = [...article_details, {article_id: newsArticle[j].article_id, data_section: newsArticle[j].data_section}];
          //       printCompletionArray = [...printCompletionArray, {contract_id: this.contractId, data_section: newsArticle[j].data_section, user_id: this.userId, read_count: 1, request_div: 2, article_id: newsArticle[j].article_id, session_id: this.session_id, user_group_name: this.user_group_name, theme_id: this.getThemeIdForPdfSuccess, theme_group_id: this.getThemeGroupIdForPdfSuccess, topics_id: this.getTopicsIdForPdfSuccess}];
          //     }
          //   }
            
          // }
          //Modified for BT08460_EXTERNAL-1784
          for(var i=0;i<newsArticle.length;i++)
          {
            for(var j=0;j<this.getArticleDetails.length;j++)
            {
              if(newsArticle[i].article_no == this.getArticleDetails[j])
              {
                // 2024/05/15  #17821  START
                if(!this.csv_download_flag){
                  if(!newsArticle[i].no_image_flag){
                    article_details.push({
                    article_id: newsArticle[i].article_id,
                    data_section: newsArticle[i].data_section
                    });
                    printCompletionArray.push({
                      contract_id: this.contractId, 
                      data_section: newsArticle[i].data_section, 
                      user_id: this.userId, read_count: 1, 
                      request_div: 2, 
                      article_id: newsArticle[i].article_id, 
                      session_id: this.session_id, 
                      user_group_name: this.user_group_name, 
                      theme_id: this.getThemeIdForPdfSuccess, 
                      theme_group_id: this.getThemeGroupIdForPdfSuccess, 
                      topics_id: this.getTopicsIdForPdfSuccess
                    });
                  }
                }else{
                  article_details.push({
                    article_id: newsArticle[i].article_id,
                    data_section: newsArticle[i].data_section
                    });
                  printCompletionArray.push({
                    contract_id: this.contractId, 
                    data_section: newsArticle[i].data_section, 
                    user_id: this.userId, read_count: 1, 
                    request_div: 2, 
                    article_id: newsArticle[i].article_id, 
                    session_id: this.session_id, 
                    user_group_name: this.user_group_name, 
                    theme_id: this.getThemeIdForPdfSuccess, 
                    theme_group_id: this.getThemeGroupIdForPdfSuccess, 
                    topics_id: this.getTopicsIdForPdfSuccess
                  });
                }
                // 2024/05/15  #17821  END
              }
            }
          }
          var pdfValues = {
            pdf_flag:2,
            article_info:article_details,
            user_id:this.userId,
            contract_code:this.contract_code,
            theme_browsing:this.theme_browsing,
            display_id:"SID0002"
          };
          
          var printSuccessValues = {
            data_info: printCompletionArray
          }
          
          var printCombinedArray = [];

          printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];

          if(this.getOut_Demand_Confirm_Message_Div_Flag)
          {
            this.$confirm(
              this.getDemandConfirmPrintMessage,
              "確認",
              {
                confirmButtonText: "OK",
                cancelButtonText: "キャンセル"
              }
            ).then(() => {
              if(this.getArticleDetails.length >= this.display_delay_message_min && this.getArticleDetails.length <= this.collective_demand_max_count)
              {
                this.$confirm(
                  "表示件数が多いため表示処理に時間がかかりますがよろしいでしょか？",
                  "確認",
                  {
                    confirmButtonText: "OK",
                    cancelButtonText: "キャンセル"
                  }
                ).then(() => {
                  this.fullscreenLoading = true;
                  this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                    this.fullscreenLoading = false;
                  })
                  .catch(() => {
                    this.fullscreenLoading = false;
                  })
                })
              }
              else
              {
                this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })
              }
            });
          }
          else
          {
            // 2021/01/11 #10236 START
            if(this.getArticleDetails.length >= this.display_delay_message_min && this.getArticleDetails.length <= this.collective_demand_max_count)
            {
              this.$confirm(
                "表示件数が多いため表示処理に時間がかかりますがよろしいでしょか？",
                "確認",
                {
                  confirmButtonText: "OK",
                  cancelButtonText: "キャンセル"
                }
              ).then(() => {
                this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })
              })
            }
            else
            {
            // 2021/01/11 #10236 END
            this.fullscreenLoading = true;
            this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
              this.fullscreenLoading = false;
            })
            .catch(() => {
              this.fullscreenLoading = false;
            })
            // 2021/01/11 #10236 START
            }
            // 2021/01/11 #10236 END
          }
        }
        else
        {
          this.$alert("1回に印刷できる記事の上限値を超えています。","確認", {
            confirmButtonText: 'OK',
          })
        }
      }
      else
      {
        this.$confirm(
            json["1023_delete_confirm_message"],
            json["1023_delete_confirm_message_title"],
            {
              showCancelButton: false,
              confirmButtonText: "OK"
            }
          );
      }
      this.$LogMethodOut("newstab","sendTo1043Screen");
    },
    //methods for setting the all article content size as small
    newsTabDecrease() {
      this.$LogButtonEvent("newstab","SmallNews");
      this.$LogMethodIN("newstab","newsDecrease");      
      $('.AllNewsTabInfiniteWrapper').css('max-height', '200px');
      this.isActive = true;
      this.isMedActive = false;
      this.isBigActive = false;
      this.$LogMethodOut("newstab","newsDecrease");
    },
    //methods for setting the all article content size as medium
    newsTabReset() {
      this.$LogButtonEvent("newstab","CurrentNews");
      this.$LogMethodIN("newstab","newsReset");      
      $('.AllNewsTabInfiniteWrapper').css('max-height', '400px');
      this.isActive = false;
      this.isMedActive = true;
      this.isBigActive = false;
      this.$LogMethodOut("newstab","newsReset");
    },
    //methods for setting the all article content size as large
    newsTabIncrease() {
      this.$LogButtonEvent("newstab","BigNews");
      this.$LogMethodIN("newstab","newsIncrease");      
      $('.AllNewsTabInfiniteWrapper').css('max-height', '700px');
      this.isActive = false;
      this.isMedActive = false;
      this.isBigActive = true;
      this.$LogMethodOut("newstab","newsIncrease");
    }, 
    TapClickedInParent(){
      this.$refs.NewsTabDraggableRef[0].noMore();
    },
    getArticlesIds() {
      var articlesIds = [];
      this.getNikkieArticle.forEach(function(article){
        articlesIds.push(article.article_no);
      })
      return articlesIds;
    }
  },
  computed: {
    ...mapGetters("situation",["getNikkieArticle",
                    "getSecondTabArticleDetails",
                    "getdatasectiondetails", 
                    "getTotalNewsCount",
                    "getSelectedTheme",
                    "getDefaultDate",
                    "getSearchConditionKey",
                    "getSearchValue",
                    "getKeywordValue",
                    "getMediaValue",
                    "getSearchStartDate",
                    "getSearchEndDate",
                    "getNewsSecondTabCheckboxValue",
                    "getDefaultThemeStartDate",
                    "getDefaultThemeEndDate",
                    "getCsvSearchDownload",
                    "getAllCheckboxSelectDetails",
                    "getCsvDownloadErrStatus",
                    "getCsvDownloadErrmsgDetail",
                    "getThemeNewsCount",
                    "getScRegisterFlag",
                    "getScrollingDate",
                    "getScrollingTitle",
                    "getThemeIdForPdfSuccess",
                    "getThemeGroupIdForPdfSuccess",
                    "getTopicsIdForPdfSuccess",
                    "getTodayArticleFlag",
                    "getPopUpBlockerFlag",
                    "getNewsFirstTabCheckboxValue",
                    "getNewsTabCheckboxSelectDetails",
                    "getArticleDetails",
                    "getSelectedSortDate",
                    "getSelectedSortTitle",
                    "getAscendingDateIcon",
                    "getDecendingDateIcon",
                    "getAscendingTitleIcon",
                    "getDecendingTitleIcon",
                    "getSortDateText",
                    "getSortTitleText",
                    "getNewsDateValue",
                    "getNewsTitleValue"]),
    ...mapGetters("situation0001", ["getUserId",
                                    "getContractId",
                                    "getThemeBrowsing",
                                    "getContractCode",
                                    "getUserGroupName",
                                    "getMC_Pdf_Print_Flag",
                                    "getServiceLinkageInfo",
                                    "getUserGroupLinkageInfo",
                                    "getCompanyConfigurationInfo",
                                    "getOut_Demand_Confirm_Message_Div_Flag",
                                    "getDemandConfirmPrintMessage",
                                    "getDemandConfirmPdfMessage",
                                    "getDefault_Font_Size"]),
  },
  mounted(){

    //get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
    this.contractId = this.getContractId;

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing;

    //get the contract code value from session
    this.contract_code = this.getContractCode;

    //get the session id value from session
    this.session_id = Vue.prototype.$session.get('session-id');

    //get the user_group_name value from session
    this.user_group_name = this.getUserGroupName;

    //get the service linkage info value from the session
    var service_linkage = this.getServiceLinkageInfo;

    for(var l=0;l<service_linkage.length;l++)
    {
      if(service_linkage[l].data_section == 1)
      {
        this.csv_download_flag = service_linkage[l].csv_output_flag;
      }
      else
      {
        //no action needed
      }
    }

    //get the user group linkage info value from the session
    var user_group_linkage = this.getUserGroupLinkageInfo;

    for(var k=0;k<user_group_linkage.length;k++)
    {
      if(user_group_linkage[k].data_section == 1 || user_group_linkage[k].data_section == 2)
      {
        this.all_articles_selectable_flag = user_group_linkage[k].all_articles_selectable_flag;
      }
      else
      {
        //no action needed
      }
    }

    //get the service linkage info value from the session
    var company_configuration_info = this.getCompanyConfigurationInfo;

    for(var s=0;s<company_configuration_info.length;s++)
    {
      if(company_configuration_info[s].configuration_key == "DELAY_MESSAGE_MAX")
      {
        this.collective_demand_max_count = company_configuration_info[s].configuration_value;
      }
      else if(company_configuration_info[s].configuration_key == "DELAY_MESSAGE_MIN")
      {
        this.display_delay_message_min = company_configuration_info[s].configuration_value;
      }
      else
      {
        //no action needed
      }
    }

    //reset the article sort displaying values to default values while loading
    this.$store.commit('situation/setSortDateTextForNewsTab', false);
    this.$store.commit('situation/setSortTitleTextForNewsTab', false);
    
  },
  updated(){
    this.TapClickedInParent();
    var font_size_flag = this.getDefault_Font_Size;
    if(font_size_flag == 0)
    {
      $('.select_custom').css({"width": "64px"});
    }
    else if(font_size_flag == 1)
    {
      $('.select_custom').css({"width": "76px"});
    }
    else
    {
      $('.select_custom').css({"width": "108px"});
    }
  }
};
</script>

<!-- --STYLE--- -->
<style>
@import "../../assets/css/style.css";

/* element ui default classes start*/

.checkList .el-checkbox__inner {
  width: var(--checkBoxWidth);
  height: var(--checkBoxHeight);
  border: 2px solid #f00 !important;
  border-radius: 4px;
} 
.checkList.is-checked .el-checkbox__inner::after {
  height: 10px;
  left: 5.9px;
  top: 1px;
  border-right-width: 2px;
  border-bottom-width: 2px;
  width: 5px;
}
.el-popover.el-popper .el-form .el-form-item .el-form-item__label {
  font-size: 12pt;
  padding-right: 8px !important;
  width: 48px;
}
.el-popover.el-popper .el-form .el-row {
  display: -webkit-box;
}
.el-input__suffix {
  right: 2px !important;
}
.el-input__inner {
  padding: 6px !important;
}
.el-icon-arrow-up:before {
  content: "\e6e1";
  font-size: 18px;
  text-shadow: 0px 0px 0.7px var(--grayDark);
}
.el-scrollbar
  > .el-select-dropdown__wrap.el-scrollbar__wrap
  > .el-select-dropdown__list {
  padding: 0px !important;
  background: var(--white) !important;
}

.el-scrollbar {
  overflow: hidden;
  position: relative;
  margin-top: -12px;
  width: 100% !important;
  box-shadow: 4px 3px 7px 0 rgba(0, 0, 0, 0.2) !important;
  border: 1px solid var(--grayLight);
  border-radius: 4px;
  background: var(--white);
}
.el-select-dropdown {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.el-popover.el-popper[x-placement^="bottom"] {
  margin-top: 0px !important;
  margin-left: -11px !important;
  width: 271px !important;
}
.el-popover {
  padding: 0px 8px 8px 8px !important;
}

.el-button.el-button--default.el-popover__reference span {
  display: block;
  background: transparent;
}

#newsTabFontSizeChange >>> .el-button {
  padding: 0px !important;
  margin: 0px !important;
}

/* element ui default classes end*/
/* -------------------------------------------------------------------------- */
/* custom css */

.dateSelect
  > .el-input.el-input--suffix.is-focus
  > .el-input__suffix
  > .el-input__suffix-inner {
  margin-right: 2px;
}
.dateSelect
  > .el-input.el-input--suffix
  > .el-input__suffix
  > .el-input__suffix-inner {
  margin-right: 2px;
}
.heading
  > .el-input.el-input--suffix.is-focus
  > .el-input__suffix
  > .el-input__suffix-inner {
  margin-right: 2px;
}
.heading
  > .el-input.el-input--suffix
  > .el-input__suffix
  > .el-input__suffix-inner {
  margin-right: 2px;
}
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.dateSelect
  .el-input {
  width: 164px;
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.dateSelect {
  width: 164px;
  margin-top: 16px;
}
.drop1 .el-select-dropdown__item.dateOption span {
  position: relative;
  display: block;
  top: 50%;
  transform: translateY(-50%);
}
.drop1 .el-select-dropdown__item.dateOption:first-child {
  margin-top: 3px;
}
.drop1 .el-select-dropdown__item.dateOption {
  height: 23px;
  margin-bottom: 3px;
}
.drop2 .el-select-dropdown__item.headingOption span {
  position: relative;
  display: block;
  top: 50%;
  transform: translateY(-50%);
}
.drop2 .el-select-dropdown__item.headingOption:first-child {
  margin-top: 3px;
}
.drop2 .el-select-dropdown__item.headingOption {
  height: 23px;
  margin-bottom: 3px;
}
.drop1 .el-select-dropdown__item.dateOption:hover {
  background-color: var(--selectHover) !important;
}
.drop2 .el-select-dropdown__item.headingOption:hover {
  background-color: var(--selectHover) !important;
}

.toolTipTop {
  width: 17px;
  position: absolute;
  left: 18px;
}
.sortIconImage {
  margin-left: 1px;
}
.selectForm > .el-form-item.dateSelectLable > .el-form-item__label {
  margin-top: 15px;
  margin-left: 30px;
}
.selectForm > .el-form-item.headingLable > .el-form-item__label {
  margin-top: 7px;
  margin-left: 30px;
}

.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.dateSelect
  > .el-input.el-input--suffix
  > .el-input__inner {
  height: 35px !important;
  border: 1px solid var(--grayLight);
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.heading {
  margin-top: 7px;
  width: 164px;
}
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.heading
  .el-input {
  width: 164px;
}
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.heading
  > .el-input.el-input--suffix
  > .el-input__inner {
  height: 35px !important;
  border: 1px solid var(--grayLight);
}

/* cancel button  */
.el-row.is-justify-space-between.el-row--flex .roundGrayDark {
  background: var(--white);
  color: var(--grayDark);
  border: 1px solid var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGrayDark:hover {
  background: var(--grayDark2);
  color: var(--white);
  border: 1px solid var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGrayDark:focus {
  background: var(--grayDark);
  color: var(--white);
  border: 1px solid var(--grayDark);
}
.el-row.is-justify-space-between.el-row--flex .el-row .roundGrayDark span {
  display: block;
  margin: 8px 11px 8px 11px;
}

/* reset button  */
.el-row.is-justify-space-between.el-row--flex .roundGray {
  background: var(--grayDark2);
  color: var(--white);
  border: 1px solid var(--grayDark2);
  margin-top: 12px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundGray:hover {
  background: var(--white);
  border: 1px solid var(--grayDark2);
  color: var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGray:focus {
  background: var(--grayDark);
  border: 1px solid var(--grayDark);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundGray span {
  display: block;
  margin: 2px 11px 2px 11px;
}
/* Okay button  */
.el-row.is-justify-space-between.el-row--flex .roundBlue {
  background: var(--selectOption);
  color: var(--secondary);
  border: 1px solid var(--secondary);
  margin-left: 8px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundBlue:hover {
  background: var(--secondary);
  border: 1px solid var(--secondary);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundBlue:focus {
  background: var(--okayFocused);
  border: 1px solid var(--okayFocused);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundBlue span {
  display: block;
  margin: 8px 24px 8px 24px;
}

.menu_grps {
  background-color: #bfaeab;
  font-size: 18px;
  display: inline;
}
#anim {
  overflow-y: hidden;
  width: 100%;
}

.accord {
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}
.NewRotate {
  -moz-transition: all 0.2s;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.NewRotate.down {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  transform: translate(-15%, -198%);
  position: absolute;
  margin: 8px 4px 4px 0px;
}
.selectList {
  height: 13pt;
}
.NewArrowRotate {
  color: var(--secondary);
  font-size: 18px;
  float: right;
  top: 50%;
  position: relative;
  transform: rotate(90deg) translate(-194%, 44%);
  margin: 8px 0px 4px 0px;
  font-weight: bold !important;
  position: absolute;
  right: 0;
  top: 38px;
}
.displaySizeLarge {
  display: inline-block;
  height: 100%;
  width: 100%;
}
.displaySizeLarge div span {
  display: block;
    position: relative;
    top: 50%;
        transform: translateY(-6px) translateX(18px);
}
.displaySizeLarge div {
  font-size: 8pt;
  float: left;
  height: 100%;
  position: relative;
  top: 50%;
  height: 15pt;
  transform: translate(19%, -50%);
  cursor: pointer;
}
.menuLable .selectList,
.menuLable .printfile,
.menuLable .fileDetail,
.menuLable .csvFile,
.menuLable .IconSort,
.menuLable .selectAll {
  position: relative;
  top: 50%;
  transform: translateY(-5px);
  line-height: 10px;
  color: #000;
}
.menuLable div {
  font-size: 8pt
}
.selectAll {
  margin-left: 4px;
  margin-top: 1px;
  height: 10pt !important;
}
.IconSort {
  margin-left: 4px !important;
  color: #000;
  margin-right: 0px !important;
}
.printfile,
.fileDetail,
.IconSort {
  margin-left: 30px;
  margin-right: 16px;
  height: 10pt !important;
}
.csvFile {
  margin-left: 26px;
  height: 10pt !important;
  margin-top: -1px;
}

.rowSpan24 {
  border: 1px solid var(--primary);  
  display: flex;
}
.newsTab24 {
  border-radius: 4px 4px 4px;
}
.menuParent2 {
  display: block;
  height: 100%;
}
.checkList {
  width: var(--checkBoxWidth);
  height: var(--checkBoxHeight);
  margin: auto 4px auto 8px !important;
}
.newsTitle {
  margin: 0px 10px;
  text-align: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.menuLable {
  display: flex;
}
.menuLable label {
  padding-left: 0px !important;
}

.menuTitle {
  font-size: 9.6pt;
  font-weight: bold;
  color: var(--white);
  background-color: var(--primary);
  min-width: 188px;
  cursor: pointer;
  height: 100%;
}

.sortIcon .el-button {
  border: none !important;
  background: transparent;
  padding: 0px !important;
  margin-top: 0px;
}
.sortIcon .el-button span {
  border: none !important;
  background: transparent;
}

.el-dropdown-link {
  cursor: pointer;
  margin-left: 5px;
}
.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
  list-style: none;
}

.list-group-item {
  cursor: move;
  font-size: 21px;
  background: #f4f4f4;
  margin: 10px 0px;
  padding: 10px;
  border: 1px solid #e4e4e4;
}

.list-group-item i {
  cursor: pointer;
}

/* Tooltip */
.display-size ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
}

.year-arrow {
    padding-left: 4px;
}

.year-drop {
  padding-left: 8px;
  margin-top: 1px;
}
.arrowSortSmall::before {
  font-size: calc(18px * 0.7) !important;
  position: relative;
    top: -2px;
padding-left: 8px;
margin-top: 1px;
}
.arrowSortSmall::before {
font-size: calc(18px * 0.7) !important;
position: relative;
top: -2px;
}

.arrowSortLarge::before {
  font-size: calc(18px * 1.3) !important;
  line-height: 2 !important;
}
#newsTabFontSizeChange  div.el-col.el-col-20  div  div:nth-child(4)  label {
  margin-left: 0px !important;
}

.year-arrow [class*=" el-icon-"], [class^="el-icon-"] {
  line-height: 1.9 !important;
}

/* Alert model popup arrow style */
.el-popper[x-placement^=bottom] .popper__arrow:first-of-type {
  display: none !important;
}
.el-popper[x-placement^=bottom] .popper__arrow{
  top: -18px !important;  
  margin-right: 3px !important;
  border-top-width: 0px !important;
  border-bottom-color: var(--grayLight) !important;
  display: block !important;
}
.el-popover.el-popper {
  margin-top: 24px !important;
  margin-left: -11px;
}
.el-select-dropdown.el-popper {
  margin-left: -10px;
  margin-top: 19px !important;
}

.el-tabs__item {
  background: var(--inActiveTab);
  margin-right: 1px;
  border-radius: 4px 4px 0px 0px;
  width: 188.86px !important;
}

/* Custom nave style */
.el-menu {
  width: 100%;
}

.el-menu--horizontal>.el-menu-item {
  height: 38px;
  padding: 0px;
  display: flex;
  border-bottom: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none;
}

.el-tooltip__popper.is-light[x-placement^=bottom] .popper__arrow {
  left: 8px !important;
}
.sortIcon, .bigPopUp {
  display: flex;
}

.menuLable .csvFile:hover {
  opacity:0.6;
}

.menuLable .fileDetail:hover {
  opacity:0.6;
}

.menuLable .printfile:hover {
  opacity:0.6;
}

.menuLable .IconSort:hover {
  opacity:0.6;
}
.select_custom_box .el-checkbox__label {
  padding-left: 4px !important;
  margin-left: 0px !important;
}
</style>
